"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = require(".");
var athlinks_results_model_1 = require("athlinks-results-model");
var lodash_1 = require("lodash");
var convert = require("conversions");
var __1 = require("..");
function buildShortLabelMap(unit) {
    return {
        singular: unit,
        plural: unit
    };
}
function buildDistanceLabelMap() {
    var map = {};
    map[athlinks_results_model_1.DistanceUnit.FEET] = function () { return ({
        'short': buildShortLabelMap(athlinks_results_model_1.DistanceUnit.FEET),
        'standard': {
            singular: 'foot',
            plural: 'feet'
        }
    }); };
    map[athlinks_results_model_1.DistanceUnit.METERS] = function () { return ({
        'short': buildShortLabelMap(athlinks_results_model_1.DistanceUnit.METERS),
        'standard': {
            singular: 'meter',
            plural: 'meters'
        }
    }); };
    map[athlinks_results_model_1.DistanceUnit.HECTA_METERS] = function () { return ({
        'short': buildShortLabelMap(athlinks_results_model_1.DistanceUnit.HECTA_METERS),
        'standard': {
            singular: '100 meter',
            plural: '100 meters'
        }
    }); };
    map[athlinks_results_model_1.DistanceUnit.HECTA_YARDS] = function () { return ({
        'short': buildShortLabelMap(athlinks_results_model_1.DistanceUnit.HECTA_YARDS),
        'standard': {
            singular: '100 yard',
            plural: '100 yards'
        }
    }); };
    map[athlinks_results_model_1.DistanceUnit.YARDS] = function () { return ({
        'short': buildShortLabelMap(athlinks_results_model_1.DistanceUnit.YARDS),
        'standard': {
            singular: 'yard',
            plural: 'yards'
        }
    }); };
    map[athlinks_results_model_1.DistanceUnit.MILES] = function () { return ({
        'short': buildShortLabelMap(athlinks_results_model_1.DistanceUnit.MILES),
        'standard': {
            singular: 'mile',
            plural: 'miles'
        }
    }); };
    map[athlinks_results_model_1.DistanceUnit.KILO_METERS] = function () { return ({
        'short': buildShortLabelMap(athlinks_results_model_1.DistanceUnit.KILO_METERS),
        'standard': {
            singular: 'kilometer',
            plural: 'kilometers'
        }
    }); };
    // The default case
    map['undefined'] = function () { return ({
        'short': buildShortLabelMap(athlinks_results_model_1.DistanceUnit.METERS),
        'standard': {
            singular: 'meter',
            plural: 'meters'
        }
    }); };
    return map;
}
var distanceLabelLongMap = buildDistanceLabelMap();
function findLabel(magnitude, unit, verbosity) {
    // There is no standard 'long' format for distance labels
    var adjustedVerbosity = (verbosity === _1.LabelVerbosity.LONG) ? _1.LabelVerbosity.STANDARD : verbosity;
    var plurality = (_1.isPlural(magnitude)) ? _1.LabelPlurality.PLURAL : _1.LabelPlurality.SINGULAR;
    return distanceLabelLongMap[unit]()[adjustedVerbosity][plurality];
}
exports.findLabel = findLabel;
function convertDistanceValue(distance, args) {
    if (args === void 0) { args = {}; }
    var distanceInMeters = distance.distanceInMeters, distanceUnit = distance.distanceUnit;
    var _a = args.precision, precision = _a === void 0 ? 1 : _a;
    // hecta meters are a special case
    if (distanceUnit === athlinks_results_model_1.DistanceUnit.HECTA_METERS) {
        return _1.makePrecise(convert(distanceInMeters, 'meters', athlinks_results_model_1.DistanceUnit.METERS) / 100, precision, distanceUnit);
    }
    // hecta yards are a special case
    if (distanceUnit === athlinks_results_model_1.DistanceUnit.HECTA_YARDS) {
        return _1.makePrecise(convert(distanceInMeters, 'meters', athlinks_results_model_1.DistanceUnit.YARDS) / 100, precision, distanceUnit);
    }
    return _1.makePrecise(convert(distanceInMeters, 'meters', distanceUnit), precision, distanceUnit);
}
exports.convertDistanceValue = convertDistanceValue;
function convertDistance(distance, args) {
    if (args === void 0) { args = {
        precision: 1
    }; }
    var distanceInMeters = distance.distanceInMeters, distanceUnit = distance.distanceUnit;
    if (distanceInMeters < 0) {
        __1.UnitLog.warn("Negative distance encountered " +
            ("(" + distanceInMeters + "), normalizing to 0."));
        return {
            value: 0,
            label: ''
        };
    }
    var _a = args.verbosity, verbosity = _a === void 0 ? _1.LabelVerbosity.SHORT : _a, _b = args.capitalize, capitalize = _b === void 0 ? false : _b;
    try {
        var value = convertDistanceValue(distance, args);
        var label = findLabel(value, distanceUnit, verbosity);
        return {
            value: value,
            label: (capitalize) ? lodash_1.capitalize(label) : label
        };
    }
    catch (_c) {
        __1.UnitLog.warn("Distance unit '" + distanceUnit + "' is not supported.");
        return {
            value: distance.distanceInMeters,
            label: athlinks_results_model_1.DistanceUnit.METERS
        };
    }
}
exports.convertDistance = convertDistance;
//# sourceMappingURL=distance.js.map